import {
  Activity, ArrowLeftRight, BookOpen, Coins, Compass, CreditCard,
  GalleryVerticalEnd, Gauge, Grid2X2, Images, LayoutDashboard, List,
  Megaphone, MessageSquare, Rocket, Settings, ShieldCheck, ShoppingBag,
  Sparkles, Users, WalletCards, WandSparkles, Wrench, BadgeDollarSign,
  ChartNoAxesCombined
} from 'lucide-react'

// Exact live R97/R100 navigation ordering from server-live-20260919.
export const EXPLORE_ITEMS = [
  ['Discover','/',Compass,null],
  ['OnlyRose Token','/token',Coins,'onlyrose-token'],
  ['Marketplace','/marketplace',ShoppingBag,'marketplace'],
  ['Listed NFTs','/listed',List,null],
  ['Collections','/collections',Grid2X2,'collections'],
  ['Launchpad','/launchpad',Rocket,'launchpad'],
  ['Activity','/activity',Activity,'activity'],
  ['My Gallery','/gallery',Images,'gated-media'],
]

export const TRADE_ITEMS = [
  ['Trade Hub','/trade',Gauge,'swap'],
  ['Swap','/swap',ChartNoAxesCombined,'swap'],
  ['Bridge','/bridge',ArrowLeftRight,'bridge'],
]

export const COMMUNITY_ITEMS = [
  ['Creator Channels','/channels',Megaphone,'content-subscriptions','channels'],
  ['My Subscriptions','/subscriptions',CreditCard,'content-subscriptions','subscriptions'],
  ['Subscriber Library','/library',BookOpen,'content-subscriptions','subscriptions'],
  ['Rose Cashier','/cashier',WalletCards,'content-subscriptions','cashier'],
]

export const NFT_CREATION_ITEMS = [
  ['Creator Overview','/creator',LayoutDashboard,'creator-factory'],
  ['Launch Collection','/launch-collection',WandSparkles,null],
  ['Revenue & Treasury','/creator/treasury',BadgeDollarSign,'creator-factory'],
]

export const CONTENT_CREATOR_ITEMS = [
  ['Creator Studio','/creator/studio',Sparkles,'content-subscriptions','channels'],
  ['Membership Tiers','/creator/tiers',BadgeDollarSign,'content-subscriptions','subscriptions'],
  ['Content Management','/creator/content',GalleryVerticalEnd,'content-subscriptions','content'],
  ['Subscribers','/creator/subscribers',Users,'content-subscriptions','subscriptions'],
  ['Community Management','/creator/community',MessageSquare,'content-subscriptions','chat'],
  ['Events Management','/creator/events',Activity,'content-subscriptions','events'],
  ['Creator Revenue','/creator/revenue',BadgeDollarSign,'content-subscriptions','subscriptions'],
]

export const ADMIN_ITEMS = [
  ['Admin Overview','/admin',ShieldCheck],
  ['Platform Modules','/admin/modules',Settings],
  ['Creator Subscriptions','/admin/subscriptions',Users],
  ['Moderation','/admin/moderation',ShieldCheck],
  ['Collection Control','/admin/collections',Grid2X2],
  ['Launchpad Control','/admin/launchpad',Rocket],
  ['Operator & Finance','/admin/operator',Wrench],
]

export const NAV_GROUPS = [
  {title:'Explore',items:EXPLORE_ITEMS},
  {title:'Trade',items:TRADE_ITEMS},
  {title:'Community',items:COMMUNITY_ITEMS,requiresSubscriptions:true,collapsible:true},
  {title:'NFT Creation',items:NFT_CREATION_ITEMS,collapsible:true},
  {title:'Content Creator',items:CONTENT_CREATOR_ITEMS,requiresSubscriptions:true,collapsible:true},
]

export const LEGACY_HASH_ROUTES = {
  discover:'/', 'onlyrose-token':'/token', marketplace:'/marketplace', listed:'/listed',
  collections:'/collections', launchpad:'/launchpad', activity:'/activity', 'my-gallery':'/gallery',
  'creator-channels':'/channels','my-subscriptions':'/subscriptions','subscriber-library':'/library','rose-cashier':'/cashier',
  'trade-hub':'/trade', swap:'/swap', bridge:'/bridge', 'creator-overview':'/creator','launch-collection':'/launch-collection',
  'revenue-treasury':'/creator/treasury','creator-studio':'/creator/studio','membership-tiers':'/creator/tiers',
  'content-management':'/creator/content',subscribers:'/creator/subscribers','community-management':'/creator/community',
  'events-management':'/creator/events','creator-revenue':'/creator/revenue','admin-overview':'/admin',
  'platform-modules':'/admin/modules','creator-subscriptions':'/admin/subscriptions',moderation:'/admin/moderation',
  'collection-control':'/admin/collections','launchpad-control':'/admin/launchpad','operator-finance':'/admin/operator'
}
